import dateMixin from "@/mixins/dateMixin";

import View from "ol/View";
import Map from "ol/Map";
import Overlay from "ol/Overlay";
import { useGeographic } from "ol/proj";
import { FullScreen, Control, defaults as defaultControls } from "ol/control.js";

import "ol/ol.css";
import "./mapStyle.scss";

import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";

import VectorSource from "ol/source/Vector";
import Cluster from "ol/source/Cluster";
import OSM from "ol/source/OSM";

import GeoJSON from "ol/format/GeoJSON";

import Icon from "ol/style/Icon";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import Text from "ol/style/Text";
import Circle from "ol/style/Circle";
import requestMixin from "@/mixins/requestMixin";

import ol from "ol";
import Feature from "ol/Feature";
import { Point } from "ol/geom";

export default {
  mixins: [dateMixin, requestMixin],

  props: {
    activeFeatureCoordinates: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      place: [43.984506, 56.305298],
      view: undefined,
      overlay: undefined,
      map: undefined,
      source: undefined,

      localActiveFeatureCoordinates: [],
    };
  },

  // watch: {
  //     activeFeatureCoordinates: {
  //         handler() {
  //             console.log(this.activeFeatureCoordinates);
  //         },
  //         deep: true,
  //     }
  // },
  mounted() {
    this.getData();
  },
  methods: {
    // получние данных
    getData() {
      let requestConf = {
        method: "get",
        url: "/public/get/map",
      };
      this.axiosRequest(requestConf)
        .then((res) => {
          this.createMap(res.data);
          if (this.$route.fullPath === "/adminPanel") {
            this.localActiveFeatureCoordinates = JSON.parse(JSON.stringify(this.activeFeatureCoordinates));
            console.log("mounted", this.localActiveFeatureCoordinates);
            this.createActiveFeature();
            this.animation(this.localActiveFeatureCoordinates);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // создание карты
    createMap(data) {
      useGeographic();
      this.view = new View({
        center: this.place,
        zoom: 12,
        minZoom: 8,
        // maxZoom: 15,
      });

      this.overlay = new Overlay({
        element: this.$refs["tooltipMap"],
        autoPan: false,
      });

      this.map = new Map({
        controls: defaultControls().extend([new FullScreen(), new RotateNorthControl()]),
        target: this.$refs["myMap"],
        view: this.view,
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
      });

      this.createSources(data);
      this.clickMap();
    },

    // создание слоев
    createSources(data) {
      let features = new GeoJSON().readFeatures(data);
      this.source = new VectorSource({
        features,
      });
      let vectorLayer = this.createFeatures({ img: "img/map/ball.svg" });
      this.map.addLayer(vectorLayer);
    },

    // стили для слоя при кластеризации
    createFeatures({ img = undefined }) {
      const clusterSource = new Cluster({
        distance: 12,
        minDistance: 12,
        source: this.source,
      });

      let clusters = new VectorLayer({
        source: clusterSource,
        style: (feature) => {
          const size = feature.get("features").length;

          let style = undefined;
          if (size === 1) {
            style = this.createStyle({ feature: feature.get("features"), imgBase: img });
          } else {
            style = createCircleStyle(size);
          }

          return style;
        },
      });

      return clusters;

      function createCircleStyle(size, opacity = 1) {
        let style = new Style({
          image: new Circle({
            radius: 22,
            stroke: new Stroke({
              color: `rgba(0, 111,190, ${opacity})`,
            }),
            fill: new Fill({
              color: `rgba(0, 111, 190, ${opacity})`,
            }),
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff",
            }),
          }),
          zIndex: !opacity === 0.5 ? 1 : 100,
        });
        return style;
      }
    },

    // стили для точки
    createStyle({ feature = undefined, imgBase = null }, opacity = 1) {
      let style = undefined;
      let img = undefined;
      if (imgBase == null) {
        img = feature[0].values_.img;
      } else {
        img = imgBase;
      }
      style = new Style({
        image: new Icon({
          src: img,
          scale: 1,
          opacity,
        }),
      });

      return style;
    },

    // клик по карте
    clickMap() {
      this.map.on("click", (e) => {
        let pixel = this.map.getEventPixel(e.originalEvent);

        this.closeToltip();
        if (this.$route.fullPath === "/") {
          this.map.forEachFeatureAtPixel(pixel, (feature, layer) => {
            let features = feature["values_"].features.map((el) => el.values_);
            if (features.length != 1) {
              this.animation(features[0].geometry.flatCoordinates);
            } else {
              this.createToltip(features[0]);
            }
          });
        } else {
          this.source.removeFeature(this.activeFeature);

          this.localActiveFeatureCoordinates = this.map.getCoordinateFromPixel(pixel);
          console.log("click", this.localActiveFeatureCoordinates);

          this.createActiveFeature();
        }
      });
    },

    // создание тултипа
    createToltip(features) {
      document.getElementById("tooltipBlock").style.display = "block";
      let closeToltip = this.closeToltip;
      let transitionPageToltip = this.transitionPageToltip;

      let element = document.getElementById("tooltipBlock");
      element.innerHTML = "";

      let titleBlock = document.createElement("div");
      titleBlock.className = "tooltip__titleBlock";

      let title = document.createElement("span");
      title.className = "tooltip__titleBlock__title";
      title.innerHTML = features.name;

      let closeBtn = document.createElement("div");
      closeBtn.className = "tooltip__titleBlock__close";
      closeBtn.onclick = function () {
        closeToltip();
      };

      titleBlock.append(title);
      titleBlock.append(closeBtn);

      let bodyBlock = document.createElement("div");
      bodyBlock.className = "tooltip__bodyBlock";
      // bodyBlock.append()
      features.description !== undefined && features.description !== null
        ? bodyBlock.append(createItemBody(features.description, "/img/map/sort.svg"))
        : console.error("features.description is", features.description);

      features.datetime !== undefined && features.datetime !== null
        ? bodyBlock.append(createItemBody(convert(features.datetime), "/img/map/clock.svg"))
        : console.error("features.datetime is", features.datetime);

      features.address !== undefined && features.address !== null
        ? bodyBlock.append(createItemBody(features.address, "/img/map/point.svg"))
        : console.error("features.address is", features.address);

      function createItemBody(valueItem, src) {
        let item = document.createElement("div");
        item.className = "tooltip__bodyBlock__item";

        let img = document.createElement("img");
        img.className = "icons";

        img.src = src;

        let value = document.createElement("span");
        value.classList.add("tooltip__bodyBlock__item__value");
        value.classList.add("tooltip__bodyBlock__item__value__active");
        value.innerHTML = valueItem;

        item.append(img);
        item.append(value);

        if (String(value.innerHTML).length > 125) {
          const p = document.createElement("p");
          p.className = "tooltip__bodyBlock__item__value__read-more";
          p.textContent = "Прочитать все";

          const wrapper = document.createElement("div");
          wrapper.className = "tooltip__bodyBlock__item__value-wrapper";

          wrapper.append(value);
          wrapper.append(p);

          item.append(wrapper);
          wrapper.addEventListener("click", (e) => {
            const elemActive = document.querySelector(".tooltip__bodyBlock");
            if (!elemActive.classList.contains("tooltip__bodyBlock_active")) {
              value.classList.remove("tooltip__bodyBlock__item__value__active");
              elemActive.classList.add("tooltip__bodyBlock_active");
              p.textContent = "Скрыть все";
            } else {
              value.classList.add("tooltip__bodyBlock__item__value__active");
              elemActive.classList.remove("tooltip__bodyBlock_active");
              p.textContent = "Прочитать все";
            }
          });
        } else {
          item.append(value);
        }

        return item;
      }

      function convert(str) {
        let date = new Date(str.split(" ")[0]);
        let time = str.split(" ")[1];
        let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
        let day = ("0" + date.getDate()).slice(-2);
        return day + "." + mnth + "." + date.getFullYear() + " " + time;
      }

      let btn = document.createElement("div");
      btn.className = "tooltip__btn";
      btn.innerHTML = "Выбрать дату";
      btn.onclick = function () {
        transitionPageToltip();
      };

      element.appendChild(titleBlock);
      element.appendChild(bodyBlock);
      element.appendChild(btn);
    },

    createToltipForEventConfirm() {
      document.getElementById("tooltipBlock").style.display = "block";
      let closeToltip = this.closeToltip;
      let setCoordinatesFromMap = this.setCoordinatesFromMap;

      let element = document.getElementById("tooltipBlock");
      element.innerHTML = "";

      let titleBlock = document.createElement("div");
      titleBlock.className = "tooltip__titleBlock";

      let title = document.createElement("span");
      title.className = "tooltip__titleBlock__title";

      let closeBtn = document.createElement("div");
      closeBtn.className = "tooltip__titleBlock__close";
      closeBtn.onclick = function () {
        closeToltip();
      };

      titleBlock.append(title);
      titleBlock.append(closeBtn);

      let bodyBlock = document.createElement("div");
      bodyBlock.className = "tooltip__bodyBlock";
      bodyBlock.innerHTML = `${String(this.localActiveFeatureCoordinates[1]).slice(0, 9)} ${String(
        this.localActiveFeatureCoordinates[0]
      ).slice(0, 9)}`;

      let btn = document.createElement("div");
      btn.className = "tooltip__btn";
      btn.innerHTML = "Выбрать точку";
      btn.onclick = function () {
        setCoordinatesFromMap();
      };

      element.appendChild(titleBlock);
      element.appendChild(bodyBlock);
      element.appendChild(btn);
    },

    // скрытие тултипа
    closeToltip() {
      if (document.getElementById("tooltipBlock").style.display != "none") {
        document.getElementById("tooltipBlock").style.display = "none";
      }
    },

    // переход на календарь
    transitionPageToltip() {
      if (this.$store.state.userIsAuthorized) {
        this.$router.push("/eventCalendar");
      } else {
        this.$router.push("/auth");
      }
    },

    // установка координат с точки
    setCoordinatesFromMap() {
      this.$emit("setCoordinates", this.localActiveFeatureCoordinates);
    },

    // Анимаци приближения
    animation(center) {
      this.view.animate({
        center: center,
        duration: 2500,
        zoom: 19,
      });
    },

    createActiveFeature() {
      this.activeFeature = new Feature({});
      let pointGeom = new Point(this.localActiveFeatureCoordinates);
      this.activeFeature.setGeometry(pointGeom);
      console.log("activeFeature", this.activeFeature);

      this.source.addFeature(this.activeFeature);
      this.createToltipForEventConfirm();
    },
  },
};

class RotateNorthControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const element = document.createElement("div");
    element.className = "tooltip";
    element.id = "tooltipBlock";

    super({
      element: element,
      target: options.target,
    });

    // closeBtn.addEventListener('click', this.close.bind(this));
    // btn.addEventListener('click', this.transitionPage.bind(this));
  }
}
